import { PageWrapper, STATUSPAGE } from '@repo/ui';
import { Card, CardBody, Input, Spinner } from 'reactstrap';

import { DailyWorkloadFiltersForm } from '../components/daily-workload-filters-form';
import { DailyWorkloadPagination } from '../components/daily-workload-pagination';
import { DailyWorkloadTable } from '../components/daily-workload-table';
import { useDailyWorkloadReport } from '../hooks/useDailyWorkloadReport';

export const ProfessionalDailyWorkloadReport = () => {
  const {
    validation,
    statusGet,
    statusExport,
    semesters,
    curricularUnits,
    groups,
    professionals,
    handleExportExcel,
    dataSource,
    hasDataSource,
    totalItems,
    selectedPage,
    totalPages,
    pages,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
  } = useDailyWorkloadReport();

  return (
    <PageWrapper title="Carga Horária Diária do Profissional">
      <div className="d-flex flex-wrap align-items-start justify-content-between gap-2 mb-3">
        <div>
          <h4 className="mb-1">Carga Horária Diária do Profissional</h4>
          <p className="text-muted mb-0">
            Visualize a carga horária e as atividades dos profissionais no
            período selecionado
          </p>
        </div>
      </div>

      <Card>
        <CardBody>
          <DailyWorkloadFiltersForm
            validation={validation}
            semesters={semesters}
            curricularUnits={curricularUnits}
            groups={groups}
            professionals={professionals}
            statusGet={statusGet}
          />
        </CardBody>
      </Card>

      <Card className="mt-3">
        <CardBody>
          <div className="d-flex align-items-center justify-content-between gap-2 mb-3">
            <div style={{ maxWidth: 280 }}>
              <Input
                type="search"
                placeholder="Pesquisar..."
                value={validation.values.search}
                onChange={(e) =>
                  validation.setFieldValue('search', e.target.value)
                }
              />
            </div>
            <button
              type="button"
              onClick={handleExportExcel}
              className="btn btn-light waves-effect waves-light"
              disabled={statusExport === STATUSPAGE.LOADING}
            >
              {statusExport === STATUSPAGE.LOADING ? (
                <Spinner size="sm">Carregando...</Spinner>
              ) : (
                <>
                  Exportar Excel
                  <i className="ri-download-2-line ms-2" />
                </>
              )}
            </button>
          </div>

          {statusGet === STATUSPAGE.LOADING ? (
            <div className="text-center py-4">
              <Spinner />
            </div>
          ) : hasDataSource ? (
            <>
              <DailyWorkloadTable
                dates={dataSource?.dates || []}
                professionals={dataSource?.professionals || []}
              />

              <DailyWorkloadPagination
                totalItems={totalItems}
                selectedPage={selectedPage}
                totalPages={totalPages}
                pages={pages}
                rowsPerPage={rowsPerPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
              />
            </>
          ) : (
            <div className="text-center py-4 text-muted">
              Nenhum registro encontrado para os filtros selecionados.
            </div>
          )}
        </CardBody>
      </Card>
    </PageWrapper>
  );
};
